import { gql } from '@apollo/client';
const AUTOCOMPLETE_USERS = gql `
  query AutocompleteUsers {
    autocomplete {
      id
      users {
        edges {
          node {
            id
            email
            avatar
            username
          }
        }
      }
    }
  }
`;
export default AUTOCOMPLETE_USERS;
